// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TZ2j","tabsBox":"styles_tabsBox__2SnpM","createButton":"styles_createButton__3nl4k"};